export default __webpack_public_path__ + "static/media/info.2975f04f.svg";